export default "__VITE_ASSET__DngqhLQM__"